import { useVahakMutationQuery } from '../hooks/useVahakQueryClient.js';
import useVahakHttpClient from '../hooks/useVahakHttpClient.js';
import API from './const.js';
import { QueryNames } from './hooks/queryNames.js';

var CallMeBackScreen;
(function (CallMeBackScreen) {
    CallMeBackScreen["CONTACT_US"] = "Contact Us Page (Web)";
    CallMeBackScreen["SUPPORT_ICON"] = "Support Floating Icon (Web)";
    CallMeBackScreen["LOAD_BID"] = "Load Bid Form (Web)";
    CallMeBackScreen["LORRY_BID"] = "Lorry Bid Form (Web)";
    CallMeBackScreen["COMPANY_REGISTER"] = "Company Register (Web)";
})(CallMeBackScreen || (CallMeBackScreen = {}));
const useCallMeBackRequest = () => {
    const { POST } = useVahakHttpClient();
    function submitCallMeBackRequest(data) {
        /**
         * The first generic is for the body type you are sending
         * Second generic is the data returned
         */
        return POST(API.CALL_ME_BACK_REQUEST, Object.assign({}, data));
    }
    /**
     * The second generic either send unknown or the error type
     */
    return useVahakMutationQuery(QueryNames.callMeBackMutate, submitCallMeBackRequest);
};

export { CallMeBackScreen, useCallMeBackRequest };
//# sourceMappingURL=callMeBack.service.js.map
